import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getEnvSettings } from '../../app/hostBasedSettings';
import { AppThunk, RootState } from '../store';

const blenderUrl = getEnvSettings().blenderUrl;
const loginUrl = blenderUrl + '/resource/login';
const activateUrl = blenderUrl + '/resource/activate';
const reserveForEmailUrl = blenderUrl + '/resource/reserveForLookup';
const completeWorkItemUrl = blenderUrl + '/resource/completeworkitem';

export interface ICompletedWorkItem {
	workItemId: string,
	closureCode: string,
	notes: string
}

export interface IBlenderMessagesState {
	loginMessage: string,
	activateMessage: string,
	reserveForEmailMessage: string,
	completeWorkItemMessage: string,
	isLoggedIn: boolean,
}

const initialState: IBlenderMessagesState = {
	loginMessage: '',
	activateMessage: '',
	reserveForEmailMessage: '',
	completeWorkItemMessage: '',
	isLoggedIn: true,
}

export const blenderApiSlice = createSlice({
	name: 'blender',
	initialState: initialState,
	reducers: {
		setLoginMessage: (state, action: PayloadAction<string>) => {
			state.loginMessage = action.payload
		},
		setActivateMessage: (state, action: PayloadAction<string>) => {
			state.activateMessage = action.payload
		},
		setReserveForEmailMessage: (state, action: PayloadAction<string>) => {
			state.reserveForEmailMessage = action.payload
		},
		setCompleteWorkItemMessage: (state, action: PayloadAction<string>) => {
			state.completeWorkItemMessage = action.payload
		},
		setLoggedInStatus: (state, action: PayloadAction<boolean>) => {
			state.isLoggedIn = action.payload
		},
	}
});

export const {
	setLoginMessage,
	setActivateMessage,
	setReserveForEmailMessage,
	setCompleteWorkItemMessage,
	setLoggedInStatus,
} = blenderApiSlice.actions;

export const login = (token: string): AppThunk => async (dispatch) => {

	let headers = {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'application/json',
	};

	const response = await fetch(loginUrl, {
		method: 'POST',
		headers: headers
	});

	if (response.status === 200) {
		dispatch(setLoginMessage('Login was successful'));
	}
	else {
		dispatch(setLoginMessage('Login was unsuccessful'));
	}

};

export const activate = (token: string): AppThunk => async (dispatch) => {

	let headers = {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'application/json',
	};

	const response = await fetch(activateUrl, {
		method: 'POST',
		headers: headers
	});

	if (response.status === 200) {
		dispatch(setActivateMessage('Blender activation was successful'));
	} else {
		dispatch(setActivateMessage('Blender activation was unsuccessful'));
	}

};

export const reserveForEmail = (token: string): AppThunk => async (dispatch) => {

	let headers = {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'application/json',
	};

	const response = await fetch(reserveForEmailUrl, {
		method: 'POST',
		headers: headers
	});

	if (response.status === 200) {
		dispatch(setReserveForEmailMessage('Email reserve was successful'));
	} else {
		dispatch(setReserveForEmailMessage('Email reserve was unsuccessful'));
	}

};

export const completeWorkItems = (completeWorkItemRequest: ICompletedWorkItem, token: string): AppThunk => async (dispatch) => {

	let headers = {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'application/json',
	};

	const response = await fetch(completeWorkItemUrl, {
		method: 'POST',
		headers: headers,
		body: JSON.stringify(completeWorkItemRequest),
	});

	if (response.status === 200) {
		dispatch(setCompleteWorkItemMessage('Set completed work item was successful'));
	} else {
		dispatch(setCompleteWorkItemMessage('Set completed work item was unsuccessful'));
	}

};

export const selectBlender = (state: RootState) =>
	state.blenderState;

export default blenderApiSlice.reducer;



